module.exports = __webpack_public_path__ + "static/media/Facebook.601923c4.svg";